/** The catalog's presentation slugs with their label keys (product dialog, order picker) */
export const PRESENTATIONS = [
  { value: 'sheets', label: 'productLineEditor.presentationSheets' },
  { value: 'reels', label: 'productLineEditor.presentationReels' },
  { value: 'rolls', label: 'productLineEditor.presentationRolls' },
  { value: 'cut_size', label: 'productDialog.presentation.cutSize' },
  { value: 'fanfold', label: 'productDialog.presentation.fanfold' },
  { value: 'ream', label: 'productDialog.presentation.ream' },
  { value: 'reams', label: 'supplierEdit.reams' },
  { value: 'other', label: 'orderDocuments.other' },
];

/** The presentations a variant can have: the API folds rolls into reels and reams into ream. */
export const VARIANT_PRESENTATIONS = PRESENTATIONS.filter(
  (p) => p.value !== 'rolls' && p.value !== 'reams'
);

const LABELS = new Map(PRESENTATIONS.map((p) => [p.value, p.label]));

export function presentationLabelKey(slug: string | null | undefined): string | null {
  return (slug && LABELS.get(slug.toLowerCase())) || null;
}

// The order line form offers Sheets, Reels and Rolls: every cut format is sheets
const FORM_VALUES: Record<string, string> = {
  sheets: 'Sheets',
  sheet: 'Sheets',
  cut_size: 'Sheets',
  fanfold: 'Sheets',
  ream: 'Sheets',
  reams: 'Sheets',
  reels: 'Reels',
  rolls: 'Rolls',
};

/** A catalog slug (or the same word typed in any case) as the order line form's value; null when unknown */
export function presentationFormValue(value: string | null | undefined): string | null {
  return (value && FORM_VALUES[value.toLowerCase()]) || null;
}

export const REEL_WORDS = ['reel', 'bobina', 'bobinas'];

/** A presentation as the order line form shows it: a known word becomes Sheets, Reels or Rolls, anything else stays */
export function presentationLineValue(value: string): string {
  const lower = value.toLowerCase();
  if (lower === 'roll') return 'Rolls';
  if (REEL_WORDS.includes(lower)) return 'Reels';
  return presentationFormValue(value) ?? value;
}

/** A line sold by the reel or roll (its size is a diameter and a width), whatever word it was written with */
export function isReelPresentation(value: string | null | undefined): boolean {
  return ['Reels', 'Rolls'].includes(presentationLineValue(value || ''));
}
